module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-swipe"
  }, [_c('p', {
    staticClass: "page-swipe-desc"
  }, [_vm._v("基础用法")]), _vm._v(" "), _c('mt-swipe', {
    staticClass: "swipe"
  }, [_c('mt-swipe-item', {
    staticClass: "slide1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/1.jpg")
    }
  })]), _vm._v(" "), _c('mt-swipe-item', {
    staticClass: "slide2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/2.jpg")
    }
  })]), _vm._v(" "), _c('mt-swipe-item', {
    staticClass: "slide3"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/3.jpg")
    }
  })])], 1), _vm._v(" "), _c('p', {
    staticClass: "page-swipe-desc"
  }, [_vm._v("隐藏 indicators")]), _vm._v(" "), _c('mt-swipe', {
    attrs: {
      "show-indicators": false,
      "auto": 0
    }
  }, [_c('mt-swipe-item', {
    staticClass: "slide1"
  }, [_vm._v("1")]), _vm._v(" "), _c('mt-swipe-item', {
    staticClass: "slide2"
  }, [_vm._v("2")]), _vm._v(" "), _c('mt-swipe-item', {
    staticClass: "slide3"
  }, [_vm._v("3")])], 1), _vm._v(" "), _c('p', {
    staticClass: "page-swipe-desc"
  }, [_vm._v("取消自动播放")]), _vm._v(" "), _c('mt-swipe', {
    attrs: {
      "auto": 0
    }
  }, [_c('mt-swipe-item', {
    staticClass: "slide1 swipe"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/1.jpg")
    }
  })]), _vm._v(" "), _c('mt-swipe-item', {
    staticClass: "slide2 swipe"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/2.jpg")
    }
  })]), _vm._v(" "), _c('mt-swipe-item', {
    staticClass: "slide3 swipe"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/3.jpg")
    }
  })])], 1), _vm._v(" "), _c('p', {
    staticClass: "page-swipe-desc"
  }, [_vm._v("设置默认显示页")]), _vm._v(" "), _c('mt-swipe', {
    attrs: {
      "auto": 0,
      "defaultIndex": 1
    }
  }, [_c('mt-swipe-item', {
    staticClass: "slide1"
  }, [_vm._v("1")]), _vm._v(" "), _c('mt-swipe-item', {
    staticClass: "slide2"
  }, [_vm._v("2")]), _vm._v(" "), _c('mt-swipe-item', {
    staticClass: "slide3"
  }, [_vm._v("3")])], 1), _vm._v(" "), _c('p', {
    staticClass: "page-swipe-desc"
  }, [_vm._v("单个幻灯片")]), _vm._v(" "), _c('mt-swipe', {
    attrs: {
      "show-indicators": false
    }
  }, [_c('mt-swipe-item', {
    staticClass: "slide1"
  }, [_vm._v("SINGLE SLIDE")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a7f1cb7","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/swipe.vue
// module id = 619
// module chunks = 0